import { css } from '@emotion/core';

export const $checkboxGroup = css`
  flex-wrap: nowrap;
  row-gap: 15px;
  margin-top: 10px;

  > *:not(:last-child) {
    margin-right: 1.2em;
  }
`;
